import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {CommitChecksLink} from './CommitChecksLink'
import {shortOid} from './short-oid'

export function MergedText({info}: {info: IssueEventInfo}) {
  const {commitOid, checksCommitOid} = info
  const merged = checksCommitOid ? <CommitChecksLink commitOid={checksCommitOid}>merged</CommitChecksLink> : 'merged'
  if (!commitOid) return <>{merged}</>
  return (
    <>
      {merged} commit <strong>{shortOid(commitOid)}</strong>
    </>
  )
}
